import { IElementContainer } from "../utils/ui/ElementContainer";
import { SimpleSignal } from "../utils/SimpleSignal";

export class AuthButton implements IElementContainer
{

	public element : HTMLElement;
	public click   : SimpleSignal;

	constructor(buttonId:string)
	{
		this.click = new SimpleSignal();
		this.element = <HTMLElement>document.querySelector('[data-buttonId="' + buttonId + '"]');
		this.element.addEventListener("click", this.onClick);
	}

	private onClick = (event:Event):void =>
	{
		this.click.dispatch();
	};

	public show()
	{
		this.element.classList.remove("hidden");
	}

	public hide()
	{
		this.element.classList.add("hidden");
	}

	public setText(value: string)
	{
		this.element.textContent = value;
	}

	public setToLogOut()
    {
        this.setText("Sign Out");
	}

    public setToLogIn()
    {
        this.setText("Sign In");
    }

    public getText()
	{
		return this.element.textContent;
	}

	public enable()
	{
		this.element.classList.remove("disabled");
	}

	public disable()
	{
		this.element.classList.add("disabled");
	}

}